import { useAtsAdminCandidateFormCreateJobApplicantProfileMutation } from './graphql/create-job-applicant-profile.v5.generated';

export const useCreateJobApplicantProfile = () =>
  useAtsAdminCandidateFormCreateJobApplicantProfileMutation({
    context: {
      clientName: 'v5',
    },
  });
